import React from "react";
import {connect} from "react-redux";
import {StyleSheet, Text, TouchableOpacity, View} from "react-native";
import {withTranslation} from "react-i18next";
import {compose} from "redux";

class BoutonText extends React.Component{
    constructor(props) {
        super(props);
        this.title = this.props.title;
    }

    render() {
        const styles = StyleSheet.create({
            ...this.props.style,
            container : {
                alignItems:"center",
                flexDirection:(this.props.right ? "row-reverse": "row"),
            },
            text : {
                color : (this.props.isRed ? this.props.theme.colors.primary.error.value: this.props.theme.colors.tertiary.black1.value),
                fontFamily: (this.props.bold ? this.props.theme.fonts.text_bold: this.props.theme.fonts.text) ,
                fontSize :14,
            },
            view : {
                //width:"100%"
                marginRight  : (this.props.right ? 3: 0)
            }
        });
        return (
            <TouchableOpacity onPress={this.props.onPress} style={[styles.container,styles.containerParent]}>
                {this.props.picto}
                <View style={[styles.view,styles.viewParent]}>
                        <Text style={[styles.text,styles.textParent]}>{this.props.t(this.title)}</Text>
                </View>
            </TouchableOpacity>
        );
    }

}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}
export default compose(withTranslation(),connect(mapStateToProps))(BoutonText);
